/* eslint-disable */
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../contexts/AppContext';

/**
 * Componente que protege las rutas según la aplicación actual
 * Previene el acceso a recursos que no pertenecen a la app activa
 */
export const RouteGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentApp } = useAppContext();

  useEffect(() => {
    const currentPath = location.pathname;

    // Definir qué recursos pertenecen a cada aplicación
    const appResources = {
      card: [
        'score',
        'goals',
        'teams',
        'members',
        'reports-teams',
        'reports-sections',
        'settings',
        'profile',
        'user-management',
      ],
      quality: ['quality', 'profile', 'user-management'],
    };

    // Extraer el nombre del recurso de la URL
    // Ejemplo: "/quality" -> "quality", "/reports-teams" -> "reports-teams"
    const pathSegments = currentPath.split('/').filter(segment => segment);
    const resourceName = pathSegments[0];

    // Si no hay recurso en la URL o es la página principal, permitir acceso
    if (!resourceName || resourceName === '' || currentPath === '/') {
      return;
    }

    // Verificar si el recurso actual es válido para la aplicación
    const allowedResources = appResources[currentApp] || [];

    if (!allowedResources.includes(resourceName)) {
      // Recurso no permitido para esta aplicación
      console.warn(
        `Acceso denegado: El recurso "${resourceName}" no está disponible en la aplicación "${currentApp}"`
      );

      // Redirigir a la página principal de la aplicación actual
      if (currentApp === 'quality') {
        navigate('/quality', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }
  }, [location.pathname, navigate, currentApp]);

  return children;
};

export default RouteGuard;
